import React from "react";
import { Box, Typography } from "@mui/material";
import { useSound } from "../../../../../../context/juno/SoundContext";
import AudioUpload from "../../../../Videos/components/AudioUpload";
import { t } from "i18next";

const AudioUploadControl: React.FC = () => {
  const { audio1, setAudio1 } = useSound();

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t("juno.sound.params.ref")}
      </Typography>
      <AudioUpload audio={audio1} setAudio={setAudio1} voice={false} />
    </Box>
  );
};

export default AudioUploadControl;
